exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper[data-v-17d5dbbd]{max-width:700px;margin:0 auto 27px}@media only screen and (min-width:40.063em){.wrapper[data-v-17d5dbbd]{margin-bottom:54px}}@media only screen and (min-width:64.063em){.wrapper[data-v-17d5dbbd]{margin-bottom:72px}}.wrapper__body[data-v-17d5dbbd]{margin-bottom:18px;padding:20px 15px;border-radius:.2em;background-color:#ededed}@media only screen and (min-width:64.063em){.wrapper__body[data-v-17d5dbbd]{padding:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-17d5dbbd","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/orders/OrderWrapper.vue
// module id = 6926cf565acce032b5c1
// module chunks = 0